import Api from "./http.js";
import i18n from "@/plugins/language/i18n";
class HttpWidgetService {
    prefix = 'superUp/admin/widget';

    api = Api.create();

    token = null;

    getTypes()
    {
        return this.api.get(`${this.prefix}/get-types`);
    }

    getProviders(id)
    {
        return this.api.get(`${this.prefix}/get-providers/${id}`);
    }

    getProducts(params) {
        return this.api.get(`${this.prefix}/get-products/`, {params: params});
    }
    getConfigIds() {
        return this.api.get(`${this.prefix}/get-templates-id-list`);
    }

    create(formData)
    {
        return this.api.post(this.prefix, formData, {
            headers: {
                'Content-Type': `multipart/form-data;`
            }
        })
    }

    update(id, formData)
    {
        return this.api.post(`${this.prefix}/${id}`, formData, {
            headers: {
                'Content-Type': `multipart/form-data;`
            }
        })
    }

    delete(id)
    {
        return this.api.delete(`${this.prefix}/${id}`);
    }

    deleteWidgetItem(id)
    {
        return this.api.delete(`${this.prefix}/widget-item/${id}`);
    }

    deleteWidget(id)
    {
        return this.api.delete(`${this.prefix}/widget/${id}`);
    }

    get(id)
    {
        return this.api.get(`${this.prefix}/${id}`, {
            headers: {
                "X-Up-Language": null,
            }
        });
    }

    getAll()
    {
        return this.api.get(`${this.prefix}`, {
            headers: {
                "X-Up-Language": null,
            }
        });
    }

    publish(id, isPublished) {
        return this.api.put(`${this.prefix}/publish`, {
            id: id,
            is_published: isPublished
        });
    }

}

export default new HttpWidgetService();
